export const SET_TOP_RESULTS_PROVIDERS = 'SET_TOP_RESULTS_PROVIDERS'
export const setTopResultsProviders = (providers: $TSFixMe) => ({
  type: SET_TOP_RESULTS_PROVIDERS,
  providers: providers,
})
